import 'babylon-grid';

$('#portfolio-images').babylongrid({
  heightDivisor: 0,
  scheme: [
      {
          minWidth: 1800,
          columns: 3
      }, {
          minWidth: 1000,
          columns: 2
      }, {
          minWidth: 0,
          columns: 1
      }
  ]
});



// WEBPACK FOOTER //
// ./src/_assets/js/modules/babylonGrid.js